import { FormPageButton } from "../components/FormPageButton";
import { Link } from "react-router-dom";
import { TrSpace } from "../components/TrSpace";

export const InquiryCompleted = () => {
    return (
        <div>
            <body className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>お問い合わせが完了しました</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <table>
                            <tr><td><p className="text-sm md:text-base px-10">お問い合わせに対する回答は、</p></td></tr>
                            <tr><td><p className="text-sm md:text-base px-10">入力いただいたメールアドレス宛にお送りします。</p></td></tr>
                            <TrSpace/>
                            <TrSpace/>
                        </table>
                        <Link to="/">
                            <FormPageButton text="ホームへ戻る"/>
                        </Link>
                    </div>
                </main>
            </body>
        </div>
    );
};